// extracted by mini-css-extract-plugin
export var btn = "fourBlocks-module--btn--SWMYp";
export var card = "fourBlocks-module--card--ntHZ5";
export var cardList = "fourBlocks-module--cardList--5KK-C";
export var container = "fourBlocks-module--container--cMWMN";
export var description = "fourBlocks-module--description--kk0jZ";
export var headTitle = "fourBlocks-module--headTitle--ihtWr";
export var img = "fourBlocks-module--img--mU3gq";
export var secondary = "fourBlocks-module--secondary--E9mun";
export var textBlock = "fourBlocks-module--textBlock--qOWwZ";
export var title = "fourBlocks-module--title--wQ9UG";